import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLicense } from '../contexts/LicenseContext';
import { useAuth } from '../contexts/AuthContext';

const LicenseCheck: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { hasValidLicense, loading, isBreweryMember, breweryId } = useLicense();

  useEffect(() => {
    // Brewery members skip license check - their access comes from the brewery
    if (isBreweryMember && breweryId) return;

    if (!loading && user && !hasValidLicense) {
      navigate('/settings');
    }
  }, [loading, hasValidLicense, user, navigate, isBreweryMember, breweryId]);

  if (loading) {
    return null; // Let app-level loading handle this
  }

  // Brewery members always pass
  if (isBreweryMember && breweryId) {
    return <>{children}</>;
  }

  // Don't render children if license is invalid - prevent flash before redirect
  if (!hasValidLicense) {
    return null;
  }

  return <>{children}</>;
};

export default LicenseCheck;
